import { CloseIcon, Dropdown, DropdownChangeEvent } from '@repo/atomic-components';
import { ChatAccessType, ChatAccessTypeLabels, ChatInvitedUser } from '@/api/chatSharing';

const ACCESS_TYPE_OPTIONS = [
  { label: ChatAccessTypeLabels.VIEWER, value: ChatAccessType.VIEWER },
  { label: ChatAccessTypeLabels.COLLABORATOR, value: ChatAccessType.COLLABORATOR },
];

export interface ChatShareRowProps {
  user: ChatInvitedUser;
  /** The name to show, with the email when another candidate has the same name. */
  label: string;
  onAccessTypeChange: (accessType: ChatAccessType) => void;
  onRemove: () => void;
  disabled?: boolean;
}

/** One access-list row: name, then the access level, then the remove control — as designed. */
export const ChatShareRow = ({ user, label, onAccessTypeChange, onRemove, disabled = false }: ChatShareRowProps) => (
  <li className="flex items-center">
    <span className="text-theme-black min-w-0 flex-1 truncate text-sm leading-[1.35]">{label}</span>

    <Dropdown
      value={user.accessType}
      options={ACCESS_TYPE_OPTIONS}
      optionLabel="label"
      optionValue="value"
      disabled={disabled}
      onChange={(event: DropdownChangeEvent) => onAccessTypeChange(event.value as ChatAccessType)}
      aria-label={`Access level for ${label}`}
      pt={{
        root: {
          className:
            '!border-theme-border-grey !bg-theme-white h-7 !w-auto shrink-0 items-center !rounded-sm !shadow-none',
        },
        input: { className: '!text-theme-black !flex-none !py-0 !pr-0 !pl-2.5 !text-xs !leading-none' },
        trigger: { className: '!w-5 !text-theme-text-grey' },
      }}
    />

    <button
      type="button"
      onClick={onRemove}
      disabled={disabled}
      aria-label={`Remove ${label} from this chat`}
      className="text-theme-black hover:bg-theme-background-grey focus-visible:outline-fletchers-green-500 ml-1 flex h-7 w-[2.125rem] shrink-0 cursor-pointer items-center justify-center rounded-sm px-2.5 outline-transparent focus-visible:outline-2 focus-visible:outline-offset-2 disabled:cursor-default disabled:opacity-60"
    >
      <CloseIcon className="h-[14px] w-[14px]" />
    </button>
  </li>
);
